import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { ProductSelectorComponent } from './product-selector.component';
import { ProductSelectorService } from './product-selector.service';
import { Observable } from 'rxjs';
import { ProductInterface } from '@vendasta/marketplace-packages';
import { PRODUCT_SELECTOR_CONFIG_TOKEN, PRODUCTS_TOKEN, ProductSelectorConfig } from './tokens';
import { ItemSearchSelectFilterModule } from '@galaxy/inventory-ui';

@NgModule({
  declarations: [ProductSelectorComponent],
  exports: [ProductSelectorComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    ItemSearchSelectFilterModule,
  ],
  providers: [
    ProductSelectorService,
    {
      provide: PRODUCTS_TOKEN,
      deps: [PRODUCT_SELECTOR_CONFIG_TOKEN],
      useFactory: productsFactory,
    },
  ],
})
export class ProductSelectorModule {}

function productsFactory(config: ProductSelectorConfig): Observable<ProductInterface[]> {
  return config.products$;
}
